export const ONBOARDING_CALENDLY_URL =
    "https://calendly.com/d/cx2b-2jh-q76/chat-with-a-roboflow-engineer";

export function trackOnboardingCalendlyOpened(source: string) {
    window.eventTracker.event({ type: "Onboarding Call Opened", data: { source } });
}

export function openOnboardingCalendly(source: string) {
    trackOnboardingCalendlyOpened(source);

    const calendlyUrl = new URL(ONBOARDING_CALENDLY_URL);
    calendlyUrl.searchParams.set("utm_source", "app");
    calendlyUrl.searchParams.set("utm_campaign", source);

    window.open(calendlyUrl.toString(), "_blank");
}
